import React, { forwardRef } from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export const DropdownMenu = DropdownMenuPrimitive.Root;
export const Trigger = DropdownMenuPrimitive.Trigger;
export const Portal = DropdownMenuPrimitive.Portal;
export const Label = DropdownMenuPrimitive.Label;
export const DropdownItem = DropdownMenuPrimitive.Item;
export const MenuGroup = DropdownMenuPrimitive.Group;
export const RadioGroup = DropdownMenuPrimitive.RadioGroup;
export const Separator = DropdownMenuPrimitive.Separator;
export const ItemIndicator = DropdownMenuPrimitive.ItemIndicator;

type ForwardedRef = React.ForwardedRef<HTMLDivElement>;

export const Content = forwardRef(function dropdownMenuContent(
  { children, ...props }: DropdownMenuPrimitive.DropdownMenuContentProps,
  ref: ForwardedRef
) {
  return (
    <DropdownMenuPrimitive.Content {...props} ref={ref}>
      {children}
    </DropdownMenuPrimitive.Content>
  );
});

export const RadioItem = forwardRef(function dropdownMenuRadioItem(
  { children, ...props }: DropdownMenuPrimitive.DropdownMenuRadioItemProps,
  ref: ForwardedRef
) {
  return (
    <DropdownMenuPrimitive.RadioItem {...props} ref={ref}>
      {children}
    </DropdownMenuPrimitive.RadioItem>
  );
});
